class EyewearPrescription {
  constructor(root) {
    this.root = root;
    this.type = root.querySelector('[data-rx-type]');
    this.methods = [...root.querySelectorAll('[data-rx-method]')];
    this.pdFormats = [...root.querySelectorAll('[data-pd-format]')];
    this.type.addEventListener('change', () => this.update());
    this.methods.forEach((control) => control.addEventListener('change', () => this.update()));
    this.pdFormats.forEach((control) => control.addEventListener('change', () => this.update()));
    this.update();
  }

  setPanel(selector, visible) {
    const panel = this.root.querySelector(selector);
    if (!panel) return;
    panel.hidden = !visible;
    panel.querySelectorAll('input, select').forEach((input) => {
      input.disabled = !visible;
      if (input.matches('[data-rx-required], [data-rx-file]')) input.required = visible;
      if (!visible && input.type !== 'radio' && input.type !== 'checkbox') input.value = '';
    });
  }

  update() {
    const isPrescription = this.type.value !== 'Non-prescription' && this.type.value !== '';
    const method = this.methods.find((control) => control.checked)?.value || 'Enter now';
    const pdFormat = this.pdFormats.find((control) => control.checked)?.value || 'Single PD';
    this.setPanel('[data-rx-prescription]', isPrescription);
    this.setPanel('[data-rx-manual]', isPrescription && method === 'Enter now');
    this.setPanel('[data-rx-upload]', isPrescription && method === 'Upload');
    this.setPanel('[data-rx-later]', isPrescription && method === 'Send later');
    this.setPanel('[data-single-pd]', isPrescription && method === 'Enter now' && pdFormat === 'Single PD');
    this.setPanel('[data-dual-pd]', isPrescription && method === 'Enter now' && pdFormat === 'Dual PD');

    const progressive = this.type.value === 'Progressive';
    this.root.querySelectorAll('[data-rx-add]').forEach((input) => { input.required = progressive && method === 'Enter now'; });
  }
}

document.querySelectorAll('[data-eyewear-rx]').forEach((root) => new EyewearPrescription(root));
